/** The `default` of an exhaustive render `switch`: a union member left unhandled fails to
 *  COMPILE (it is not assignable to `never`), and a value outside the type at runtime renders
 *  nothing rather than handing React a raw object. */
export function unhandledCase(_value: never): null {
  return null;
}
